<template>
	<r-standard-modal-form
		class="primary-column-modal-outter"
		:style="{
			width: `264px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<span slot="title">{{ titleText }}</span>
		<div slot="body" class="primary-column-modal-body">
			<div class="input-header">Workbook Columns</div>
			<div
				class="primary-column-list"
			>
				<div
					class="primary-column-list-item"
					v-for="(fieldStruct, index) in availablePrimaryColumns"
					:key="fieldStruct.key"
					@click="toggleColumnFilter(fieldStruct.key)"
				>
					<r-standard-icon
						v-if="fieldStruct.key === proposedPrimaryColumnGUID"
						class="column-icon"
						icon="checkMarkOn"
					></r-standard-icon>
					<r-standard-icon
						v-else
						class="column-icon"
						icon="checkMarkOff"
					></r-standard-icon>
					<universal-field-label-display
						:dataStore="dataStore"
						:fieldGUID="fieldStruct.key"
					/>
				</div>
			</div>
			<r-button 
				theme="dark-blue" 
				fullWidth 
				class="submit-button" 
				@click="submit"
			>
				Done
			</r-button>
		</div>
	</r-standard-modal-form>
</template>
<script>

import DataStoreFields from 'js/data-store/data-store-fields/data-store-fields';
import CommonVueFunctions from 'vue/sheet-views/common/common-vue-functions';

import UniversalFieldLabelDisplay from 'vue/sheet-views/common/fields/universal-field-label-display';

export default {
	name:'filter-columns-modal',
	$pubsub:{
		newColumnModal:{},
	},
	data(){
		return{
			proposedPrimaryColumnGUID: null,
		};
	},
	components:{
		UniversalFieldLabelDisplay,
	},
	inject:['workbookHasPermission', 'sheetGlobalState'],
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
		dataStore:{
			required: true,
			type: Object,
		},
	},
	mounted(){
		this.proposedPrimaryColumnGUID = this.currentPrimaryColumnGUID;
	},
	computed:{
		schemaObject(){
			return this.dataStore.meta.schema;
		},
		sortedFields(){
			return CommonVueFunctions.computed.sortedFields.apply(this, [true]).slice(0, -1);
		},
		filteredFields(){
			return this.sortedFields.slice(1).filter(function isField(field){
				return field.type === 'field';
			});
		},
		nameFieldGUID(){
			return this.sortedFields[0].guid;
		},
		visibleColumns(){
			const vcSelf = this;
			return vcSelf.sortedFields.filter(function onlyShownFields(fieldStruct){
				if(fieldStruct.guid === vcSelf.nameFieldGUID){
					return true;
				}
				if(vcSelf.sheetView.properties.fields.shownFields){
					return vcSelf.sheetView.properties.fields.shownFields.indexOf(fieldStruct.guid) >= 0;
				}
				return false;
			});
		},
		numberVisibleColumns(){
			return this.visibleColumns.length;
		},


		availablePrimaryColumns(){
			const vcSelf = this;
			return vcSelf.filteredFields.filter(function onlyPrimaryAvailableColumns(fieldStruct){
				let fieldType = fieldStruct.properties.field.fieldType;
				if(typeof(DataStoreFields.fieldTypes[fieldType].features.primaryColumn.canBePrimaryColumn) === 'function'){
					return DataStoreFields.fieldTypes[fieldType].features.primaryColumn.canBePrimaryColumn({
						dataStore: vcSelf.dataStore,
						fieldGUID: fieldStruct.key,
						systemState: vcSelf.$root.systemState,
						ConnectedApps: vcSelf.sheetGlobalState.ConnectedApps,
					});
				}
				else if(DataStoreFields.fieldTypes[fieldType].features.primaryColumn.canBePrimaryColumn){
					return DataStoreFields.fieldTypes[fieldType].features.primaryColumn.canBePrimaryColumn;
				}
				else{
					return false;
				}
			});
		},
		currentPrimaryColumnGUID(){
			return this.schemaObject.getPrimaryNameFieldGUID();
		},
		titleText(){
			return `Select Primary Column`;
		},
	},
	methods:{
		toggleColumnFilter(fieldGUID){
			this.proposedPrimaryColumnGUID = fieldGUID;
		},
		submit(){
			this.$emit('closeModal');
			this.schemaObject.setPrimaryFieldGUID(this.proposedPrimaryColumnGUID);
		},
	},
}
</script>

<style scoped lang="scss">
	
.primary-column-modal-outter{
	width: 100%;

	.primary-column-modal-body{
		width: 100%;

		.input-header{
			font-family: $rvFontFamily;
			font-weight: 600;
			font-size: 13px;
			line-height: 19px;
			letter-spacing: 0.01em;
			color: $p-color-grey-400;
			margin-bottom: 6px;
		}

		.primary-column-list{
			max-height: 360px;
			overflow-y: auto;
			margin-bottom: 24px;

			.primary-column-list-item{
				@include flex(row, flex-start);
				width: 100%;
				height: 36px;
				cursor: pointer;

				&:hover{
					background: $p-color-grey-100;
				}

				&:active{
					filter: brightness(98%);
				}

				.column-icon{
					margin-left: 6px;
					margin-right: 6px;
				}
			}
		}
	}
}

</style>
